import type { PermissionTag } from '@vlabs/api/artemy/model/PermissionTag';
import type { PermissionTagRecord } from '@vlabs/api/artemy/model/PermissionTagRecord';
import type { BuildTableViewCellProps, TableCtx, TBuildTableViewCell } from '@vlabs/monokit/shared/ui/table-view';
import {
  buildTableViewCell,
  getTestIdFromTableCtx,
} from '@vlabs/monokit/shared/ui/table-view';

type TSharedCtx<TValue = unknown> = TableCtx<PermissionTagRecord, TValue>;
const getPermissionTagRowTestId = (
  permissionTag: PermissionTagRecord,
): PermissionTag | undefined => permissionTag.permission_tag;

export { renderHeader, renderCell } from '@vlabs/monokit/shared/ui/table-view';

function createPermissionTagCell(
  props: BuildTableViewCellProps,
): <TValue>(ctx: TSharedCtx<TValue> | undefined) => TBuildTableViewCell {
  return (ctx) => buildTableViewCell({
    ...props,
    ...getTestIdFromTableCtx(ctx, getPermissionTagRowTestId),
  });
}

export const permissionTagCell = createPermissionTagCell({
  style: { flex: '0 0 280px' },
});

export const createdByUserCell = createPermissionTagCell({
  style: { flex: '0 0 200px' },
});

export const createTimeCell = createPermissionTagCell({
  style: { flex: '0 0 174px' },
});

export const groupCell = createPermissionTagCell({
  style: { flex: '1 1 0' },
});

export const actionCell = createPermissionTagCell({
  style: {
    flex: '0 0 40px',
    padding: 0,
  },
});

export const dividerCell = buildTableViewCell({
  style: {
    flex: '0 0 16px',
    padding: 0,
  },
});
